import { render, staticRenderFns } from "./BusinessHandle.vue?vue&type=template&id=0fdf947a&scoped=true"
import script from "./BusinessHandle.vue?vue&type=script&lang=js"
export * from "./BusinessHandle.vue?vue&type=script&lang=js"
import style0 from "./BusinessHandle.vue?vue&type=style&index=0&id=0fdf947a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf947a",
  null
  
)

export default component.exports